"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var SettingsMenu_1 = __importStar(require("./SettingsMenu"));
var SettingsGeneral_1 = __importDefault(require("./SettingsGeneral"));
var use_stores_1 = require("hooks/use-stores");
var utils_1 = require("../../util/utils");
var use_notification_1 = require("../../hooks/use-notification");
var Notification_1 = require("../Notification");
var SettingsPage = mobx_react_1.observer(function () {
    var _a = react_1.useState(SettingsMenu_1.SettingsPages.GENERAL), page = _a[0], setPage = _a[1];
    var userStore = use_stores_1.useStores().userStore;
    var settings = userStore.data.settings;
    var notification = use_notification_1.useNotification();
    react_1.useEffect(function () {
        document.title = 'Shop CMS - Settings';
    }, []);
    var changePageHandler = function (newPage) {
        setPage(newPage);
    };
    var changeSettingHandler = function (name, value) {
        var _a, _b;
        api_1.default.editSelf({
            settings: __assign(__assign({}, settings), (_a = {}, _a[page] = __assign(__assign({}, settings[page]), (_b = {}, _b[name] = utils_1.checkAndConvertNumber(value), _b)), _a))
        })
            .then(function (response) {
            userStore.setData(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Settings have been saved'
            });
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'page thin-scroll settings' },
        react_1.default.createElement("div", { className: 'settings__title-band' },
            react_1.default.createElement("h1", null, "Settings")),
        react_1.default.createElement("div", { className: 'settings__content flex flex-row' },
            react_1.default.createElement(SettingsMenu_1.default, { page: page, onChangePage: changePageHandler }),
            react_1.default.createElement("div", { className: 'settings__items' }, page === SettingsMenu_1.SettingsPages.GENERAL &&
                react_1.default.createElement(SettingsGeneral_1.default, { data: settings, onChange: changeSettingHandler })))));
});
exports.default = SettingsPage;
